var Conversation = (function(Conversation) {

  Conversation.Thread = {

    // Constructor
    init: function() {
      this.messages = {};
      this.message_list = $('.cw-conversation-messages');
      if (!this.message_list.length) {
        return; // XXX do we want to fail silently?
      }

      this.resizeThread();
      this.scrollToBottom();

      // Handle the form
      new Conversation.Sender('.cw-conversation-form');
    },

    /**
     * Be sure the messages view is always at the bottom
     */
    scrollToBottom: function() {
      var new_scroll_position = this.message_list[0].scrollHeight - this.message_list.outerHeight();
      this.message_list.scrollTop(new_scroll_position);
    },

   /**
    * Be sure the thread occupies the right space
    */
    resizeThread: function() {
      // Don't bother if we are not in mobile
      if (!Modernizr.mq('only screen and (max-width: 746px)')) {
        return;
      }

      // Cache all the elements
      this.elems = this.elems || $('.cw-header').add('.cw-conversation-title').add('.cw-conversation-order').add('.cw-conversation-form').toArray();
      var total_height = $(window).height();
      var avail_height = total_height -
        parseInt(this.message_list.css('padding-top'), 10) -
        parseInt(this.message_list.css('padding-bottom'), 10) -
        this.elems.reduce(function(sum, el) {
          return sum + el.offsetHeight;
        }, 0);
      this.message_list.css('height', avail_height);

    },

    /**
     * Adds a message to the message list
     * @param Object message_data
     * @param Boolean sending - Show message with a "sending" state
     * @return String
     */
    addMessage: function(message_data, sending) {
      if (sending === undefined) {
        sending = true;
      }

      var body = message_data['message[body]'];
      if (!body) { return; }

      var body = nl2br( $.trim(body) );
      var message_id = 'cw-message-' + rand_id(10);
      var message_view = $('<div></div>', {
        'class': 'cw-conversation-message cw-conversation-message-mine' +
               (sending ? ' cw-conversation-message-sending' : ''),
        id: message_id,
      }).append($('<div></div>', {
        'class': 'cw-conversation-message-bubble',
        html: body
      })).append($('<p></p>', {
        'class': 'cw-conversation-message-received-at',
        text: strftime('%H:%M')
      })).appendTo(this.message_list);

      this.messages[message_id] = message_view;
      this.scrollToBottom();
      return message_id;
    },

    /**
     * Adds an attachment to the message list
     */
    addAttachment: function(attachment) {
      var template = tmpl($('#tmpl-conversation-message-attachment').html());

      var messageView = $('<div></div>', {
        'class': 'cw-conversation-message cw-conversation-message-mine'
      }).append($('<div></div>', {
        'class': 'cw-conversation-message-bubble',
        html: template(attachment)
      })).append($('<p></p>', {
        'class': 'cw-conversation-message-received-at',
        text: strftime('%H:%M')
      })).appendTo(this.message_list);
      this.scrollToBottom();
    },

    /**
     * Mark a message as sent
     *
     * @param String message_id
     */
    markAsSent: function(message_id) {
      var message_view = this.messages[message_id];
      if (message_view) {
        message_view.removeClass('cw-conversation-message-sending');
      }
    }
  };

  /**
   * Generate a random alphanumeric ID
   * @param Number length - Lenght of the ID
   * @return String
   */
  function rand_id(length) {
    return Math.random().toString(36).substr(2, length);
  }

  /**
   * Replace all new line characters with <br/> to render the text in HTML
   */
  function nl2br(str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }


  $(document).ready(function() {
    Conversation.Thread.init();
  });

  return Conversation;

})(Conversation || {});
